document.addEventListener("DOMContentLoaded", async function () {
    const checkboxes = document.querySelectorAll("#add-sofa-retire")
    // const checkbox = checkboxes[1] ? checkboxes[1] : checkboxes[0]
    function checkForSofa() {
        fetch('/cart.js').then(res => res.json()).then(data => {
            const { items } = data
            const hasCouch = items.some(item => item.id === 43155558760684)
            if (hasCouch) {
                for (const cb of checkboxes) {
                    cb.checked = true
                }
            }
        })
    }

    checkForSofa()
    function handleClick() {
        if (this.checked) {
            addToCart()
        } else {
            removeFromCart()
        }
    }
    for (const cb of checkboxes) {
        cb.addEventListener('change',handleClick);
    }

    const modalButton = document.getElementById('qmark');
    modalButton.addEventListener('click',()=>{
        const addOnModal = document.getElementById(`sofa-modal`);
        addOnModal.classList.add('show');
    });

});




function addToCart() {
    const data = {
        "id": 43155558760684,
        "quantity": 1
    }
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(()=>{
        location.reload()
    })
}

function removeFromCart() {
    const data = {
        updates: {
            "43155558760684": 0,
        }
    }

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(res => res.json()).then(data => {
        location.reload()
    })
}
